var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "navigation-link",
      class: _vm.icon,
      attrs: { exact: _vm.exact, id: _vm.id, params: _vm.params, to: _vm.to }
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _vm.notificationCount
        ? _c("span", { staticClass: "notification" }, [
            _vm._v(_vm._s(_vm.notificationCount))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46a86d80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46a86d80","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/navigation-link.vue
// module id = 1343
// module chunks = 0